import React, { type TextareaHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import NoTrailingSpace from "src/shared/forms/validations/NoTrailingSpace";
import { required as Required } from "src/shared/forms/validations/Required";

const MIN_LIST_DESCRIPTION_CHARS: number | undefined = 3;
const MAX_LIST_DESCRIPTION_CHARS: number | undefined = 100;
const ListDescriptionValidation = Length(
  MIN_LIST_DESCRIPTION_CHARS,
  MAX_LIST_DESCRIPTION_CHARS,
);

export interface IListDescriptionInputProps
  extends IFormInputs,
    TextareaHTMLAttributes<HTMLTextAreaElement> {}

export default (props: IListDescriptionInputProps) => {
  const {
    inputID,
    label = <FormattedMessage id="lists.description" />,
    validationDisabled,
    ...rest
  } = props;
  return (
    <Field
      name={inputID}
      label={label}
      type="textarea"
      component={InputRenderer}
      validate={
        !validationDisabled
          ? [Required, ListDescriptionValidation, NoTrailingSpace]
          : undefined
      }
      {...rest}
    />
  );
};
